import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { ResendPORequestItem } from 'src/types/edi';
import axiosInstance from 'src/utils/axios';

const useResendPOsMutation = () =>
  useMutation({
    mutationFn: async (body: ResendPORequestItem[]) => {
      await axiosInstance.post(api.resendPOs, body);
    },
  });

export default useResendPOsMutation;
